export enum RowStatus {
    Active = 1,
    InActive = 2,
    Delete = 3,
      Clear = 4
}

export enum PurchaseFlow {
  Enrollment = 1,
  Personal_Order = 2,
  Autoship_Order = 3,
  Offic_POS = 4,
  Event_POS = 5,
  Retail = 6,
  PERSONAL= 7,
  SERVICE = 8
}


export  enum  MemberLevel  {
    RETAIL = 1,
    PREFERREDCUSTOMER = 2,
    ASSISTANTSUPERVISOR = 3,
    SUPERVISOR = 4,
    ASSISTANTMANAGER = 5,
    MANAGER = 6,
    UNRECOGNIZEDMANAGER = 7,
    RECOGNIZEDMANAGER = 8,
    SENIORMANAGER = 9,
    SOARINGMANAGER = 10,
    SAPPHIREMANAGER = 11,
    DIAMONDSAPPHIREMANAGER = 12,
    DIAMONDMANAGER = 13,
    DOUBLEDIAMONDMANAGER = 14,
    TRIPLEDIAMONDMANAGER = 15,
    DIAMONDCENTURIONMANAGER = 16,
    GUEST = 18,
    NOVICCUSTOMER =17
}




export enum OrderType {
    REGULAR = 1,
    REPLACEMENT = 2,
    POS = 3,
    NEW_GUEST_RETAIL = 4,
    NEW_RETAIL = 5,
    NEW_FPC = 6,
    NEW_FBO = 7,
    SERVICE_ORDER = 8
}

export enum OrderTypeValues {
    SERVICE = 'SERVICE'
}

export enum DeliveryPreference {
    DELIVERY = 1,
    PICKUP = 2,
    DROPSHIP = 42
}

export enum BusinessEntityIdType {
    CORPORATION = 113,
    LIABILITY = 114,
    OTHER_BUSINESS_ENTITY = 115,
    TRUST = 116
}

export enum MemberStatusId {
  ACTIVE = 1,
  IN_COMPLETE = 2,
  SUSPENDED = 3,
  TERMINATED = 4,
  DECLINED = 5,
  PENDING = 6,
  RESTRICTED = 7
}

export enum ProductType {
  Simple = 1,
  Variable = 2,
  Kit = 3,
  Configurable_Kit = 4
}

export enum OrderSources {
  WEB = 1,
  CUSTOMER =2,
  AUTOSHIP = 3,
  POS = 4
}

export enum TitleValue {
  MR = '126',
  MRS = '127',
  MS = '128'
}

export enum PromotionOrderType{
  SHOP =19,
  JOIN =20,
  AUTOSHIP = 21
}

export enum PromotionActionType{
  ORDER = 11,
  ORDERSUBTOTAL = 12,
  ORDERCC = 13,
  PRODUCT =14,
  PRODUCT_QUANTITY =15,
  MULTIPLE_PRODUCTS =16,
  CONSECUTIVE_AUTOSHIP =17
}
export enum OrderTypeTitle{
  ENROLLMENT = 1 ,
  PERSONAL = 2,
  AUTOSHIP = 3,
  OFFICE_POS = 4,
  EVENT_POS = 5,
  RETAIL = 6,
  AMZUS = 7,
  SERVICE = 8
}
export enum cancelOrderOptions{
  CANCEL = 'Cancel',
  CANCELANDREFUND ='CancelAndRefund'
}

export enum BonusStatus {
  OPEN = 2,
  RESTRICTED = 4,
  CLOSED_AND_PUBLISHED = 11
}




// WEBPACK FOOTER //
// ./src/app/customerservice/common/enumerations.ts